<p-confirmdialog></p-confirmdialog>
<app-toast />

<div class="contato-container">
    @if (carregamentoInicialSemDados()) {
        <div class="flex justify-center items-center py-8 min-h-[160px]">
            <p-progressSpinner ariaLabel="Carregando contatos"></p-progressSpinner>
        </div>
    }

    <div class="endereco-section">
        <app-card-content icon="pi pi-map-marker" title="Endereços">
            <div card-header>
                @if (podeExibirAcoesContato()) {
                    <p-button label="Adicionar Endereço" icon="pi pi-plus-circle" size="small" [appCan]="roleEditarContato()" [appCanUf]="ufContato()" (onClick)="showEnderecoDialog()" />
                }
            </div>

            <div class="mt-4 mb-8">
                <app-custom-table [data]="enderecosFormatados()" [metadata]="enderecosTableMetadata()" [loading]="loadingEndereco" [columnOrder]="enderecosColumnOrder" [initialViewMode]="initialViewMode()" [useCustomCard]="true" [cardColumns]="2">
                    <ng-template pTemplate="card" let-rowData>
                        <app-card-container [hoverEfect]="true" class="contato-card-item block h-full">
                            <div class="contato-card-header">
                                <div class="contato-card-title-row">
                                    <div class="contato-card-badges-row">
                                        <p-tag [value]="obterTipoEnderecoExibicao(rowData.tipo)" [rounded]="true" [style]="{ 'background-color': obterTipoEnderecoColor(rowData.tipo), color: '#ffffff' }"></p-tag>
                                    </div>
                                    <h3 class="contato-card-title" [title]="rowData.logradouro">
                                        {{ obterLogradouroExibicao(rowData) }}
                                    </h3>
                                </div>
                            </div>

                            <div class="contato-card-body">
                                <!-- Bairro -->
                                <div class="contato-card-row">
                                    <i class="pi pi-map"></i>
                                    <span class="contato-card-field-value">
                                        Bairro: <span>{{ rowData.bairro || 'N/A' }}</span>
                                    </span>
                                </div>

                                <!-- Município/UF -->
                                <div class="contato-card-row">
                                    <i class="pi pi-map-marker"></i>
                                    <span class="contato-card-field-value">
                                        Município/UF: <span>{{ rowData.municipioNome || 'N/A' }} / {{ rowData.uf || 'N/A' }}</span>
                                    </span>
                                </div>

                                <!-- CEP -->
                                <div class="contato-card-row">
                                    <i class="pi pi-envelope"></i>
                                    <span class="contato-card-field-value">
                                        CEP: <span>{{ rowData.cep || 'N/A' }}</span>
                                    </span>
                                </div>

                                <!-- Telefones -->
                                @for (tel of rowData.telefones; track tel) {
                                    <div class="contato-card-row">
                                        <i class="pi pi-phone"></i>
                                        <span class="contato-card-field-value">
                                            Telefone: <span>{{ tel }}</span>
                                        </span>
                                    </div>
                                }
                            </div>

                            @if (enderecosTableMetadata().actions) {
                                <div class="contato-card-actions">
                                    @for (action of enderecosTableMetadata().actions | keyvalue; track action.key) {
                                        <p-button
                                            [icon]="action.value.icon"
                                            [styleClass]="'p-button-text p-button-' + action.value.color"
                                            [rounded]="true"
                                            [pTooltip]="action.value.label"
                                            tooltipPosition="top"
                                            (onClick)="action.value.command(rowData); $event.stopPropagation()"
                                        ></p-button>
                                    }
                                </div>
                            }
                        </app-card-container>
                    </ng-template>
                </app-custom-table>
            </div>
        </app-card-content>
    </div>

    <div class="emails-grid mt-4">
        <app-card-content icon="pi pi-envelope" title="E-mails">
            <div card-header>
                @if (podeExibirAcoesContato()) {
                    <p-button label="Adicionar E-mail" icon="pi pi-plus-circle" size="small" [appCan]="roleEditarContato()" [appCanUf]="ufContato()" (onClick)="showEmailDialog()" />
                }
            </div>

            <div class="mt-4">
                <app-custom-table [data]="emailsFormatados()" [metadata]="emailTableMetadata()" [loading]="loadingEmail" [columnOrder]="emailsColumnOrder" [initialViewMode]="initialViewMode()" [useCustomCard]="true" [cardColumns]="2">
                    <ng-template pTemplate="card" let-rowData>
                        <app-card-container [hoverEfect]="true" class="contato-card-item block h-full">
                            <div class="contato-card-header">
                                <div class="contato-card-title-row">
                                    <div class="contato-card-badges-row">
                                        <p-tag [value]="rowData.tipoDescricao" [rounded]="true" [style]="{ 'background-color': obterTipoEmailColor(rowData.tipo), color: '#ffffff' }"></p-tag>
                                    </div>
                                    <h3 class="contato-card-title" [title]="rowData.email">
                                        {{ obterEmailExibicao(rowData) }}
                                    </h3>
                                </div>
                            </div>

                            <div class="contato-card-body">
                                <div class="contato-card-row">
                                    <i class="pi pi-envelope"></i>
                                    <span class="contato-card-field-value">
                                        E-mail: <span>{{ rowData.email }}</span>
                                    </span>
                                </div>
                            </div>

                            @if (emailTableMetadata().actions) {
                                <div class="contato-card-actions">
                                    @for (action of emailTableMetadata().actions | keyvalue; track action.key) {
                                        <p-button
                                            [icon]="action.value.icon"
                                            [styleClass]="'p-button-text p-button-' + action.value.color"
                                            [rounded]="true"
                                            [pTooltip]="action.value.label"
                                            tooltipPosition="top"
                                            (onClick)="action.value.command(rowData); $event.stopPropagation()"
                                        ></p-button>
                                    }
                                </div>
                            }
                        </app-card-container>
                    </ng-template>
                </app-custom-table>
            </div>
        </app-card-content>
    </div>

    <p-dialog
        appDialogoPadrao="pi pi-map-marker"
        descricao="Endereço adicionado ao contato."
        header="Novo Endereço"
        [(visible)]="displayEnderecoDialog"
        [style]="{ width: '600px', maxWidth: '90vw' }"
        styleClass="p-0"
        [contentStyle]="{ overflow: 'visible' }"
    >
        <form [formGroup]="enderecoForm" class="flex flex-col gap-5 pt-2">
            <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                <label for="cep" class="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">CEP</label>
                <div class="flex gap-2">
                    <p-inputMask id="cep" mask="99.999-999" formControlName="cep" placeholder="00.000-000" styleClass="w-32"></p-inputMask>
                    <div class="flex items-center text-xs text-slate-400 italic"><i class="pi pi-info-circle mr-1"></i> Digite o CEP para buscar o endereço</div>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div class="md:col-span-3 flex flex-col gap-1.5">
                    <span class="flex items-center gap-1">
                        <label for="logradouro" class="text-sm font-bold text-slate-700">Logradouro</label>
                        <i class="pi pi-map"></i>
                    </span>
                    <input
                        pInputText
                        id="logradouro"
                        formControlName="logradouro"
                        maxlength="70"
                        class="w-full"
                        placeholder="Rua, Avenida..."
                        [attr.aria-invalid]="campoEnderecoInvalido(enderecoForm, 'logradouro') ? true : null"
                        [attr.aria-describedby]="campoEnderecoInvalido(enderecoForm, 'logradouro') ? 'erro-logradouro' : null"
                    />
                    @if (campoEnderecoInvalido(enderecoForm, 'logradouro')) {
                        <small class="erro-campo" id="erro-logradouro">{{ mensagemErroEndereco(enderecoForm, 'logradouro') }}</small>
                    }
                </div>
                <div class="flex flex-col gap-1.5">
                    <label for="numero" class="text-sm font-bold text-slate-700">Número</label>
                    <input
                        pInputText
                        id="numero"
                        formControlName="numero"
                        inputmode="numeric"
                        maxlength="10"
                        class="w-full"
                        [attr.aria-invalid]="campoEnderecoInvalido(enderecoForm, 'numero') ? true : null"
                        [attr.aria-describedby]="campoEnderecoInvalido(enderecoForm, 'numero') ? 'erro-numero' : null"
                    />
                    @if (campoEnderecoInvalido(enderecoForm, 'numero')) {
                        <small class="erro-campo" id="erro-numero">{{ mensagemErroEndereco(enderecoForm, 'numero') }}</small>
                    }
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="flex flex-col gap-1.5">
                    <label for="complemento" class="text-sm font-bold text-slate-700">Complemento</label>
                    <input
                        pInputText
                        id="complemento"
                        formControlName="complemento"
                        maxlength="30"
                        class="w-full"
                        [attr.aria-invalid]="campoEnderecoInvalido(enderecoForm, 'complemento') ? true : null"
                        [attr.aria-describedby]="campoEnderecoInvalido(enderecoForm, 'complemento') ? 'erro-complemento' : null"
                    />
                    @if (campoEnderecoInvalido(enderecoForm, 'complemento')) {
                        <small class="erro-campo" id="erro-complemento">{{ mensagemErroEndereco(enderecoForm, 'complemento') }}</small>
                    }
                </div>
                <div class="flex flex-col gap-1.5">
                    <label for="bairro" class="text-sm font-bold text-slate-700">Bairro</label>
                    <input pInputText id="bairro" formControlName="bairro" class="w-full" maxlength="30" />
                    <small *ngIf="enderecoForm.get('bairro')?.errors?.['maxlength']" class="text-red-500 font-medium"> O bairro deve ter no máximo 30 caracteres </small>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-slate-50 rounded-xl border border-slate-100">
                <div class="md:col-span-2 flex flex-col gap-1.5">
                    <label for="municipio" class="text-sm font-bold text-slate-700">Município</label>
                    <p-select
                        [options]="municipios()"
                        formControlName="municipio"
                        optionLabel="dsMunicipio"
                        optionValue="id"
                        [filter]="true"
                        filterBy="dsMunicipio"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="38"
                        styleClass="w-full bg-white"
                        placeholder="Selecione o município"
                    >
                    </p-select>
                </div>
                <div class="flex flex-col gap-1.5">
                    <label for="uf" class="text-sm font-bold text-slate-700">UF</label>
                    <input
                        pInputText
                        id="uf"
                        formControlName="uf"
                        maxlength="2"
                        class="w-full bg-white"
                        [attr.aria-invalid]="campoEnderecoInvalido(enderecoForm, 'uf') ? true : null"
                        [attr.aria-describedby]="campoEnderecoInvalido(enderecoForm, 'uf') ? 'erro-uf' : null"
                    />
                    @if (campoEnderecoInvalido(enderecoForm, 'uf')) {
                        <small class="erro-campo" id="erro-uf">{{ mensagemErroEndereco(enderecoForm, 'uf') }}</small>
                    }
                </div>
            </div>

            <div class="flex flex-col gap-1.5">
                <label for="tipo" class="text-sm font-bold text-slate-700">Tipo de Endereço</label>
                <p-select [options]="tiposEndereco" formControlName="tipo" optionLabel="label" optionValue="value" styleClass="w-full" placeholder="Selecione o tipo"></p-select>
            </div>
        </form>
        <ng-template pTemplate="footer">
            <div class="w-full flex justify-end gap-3 pt-4 border-t border-slate-100">
                <p-button icon="pi pi-times" (click)="displayEnderecoDialog = false" label="Cancelar" styleClass="p-button-text p-button-secondary"></p-button>
                <p-button icon="pi pi-check" (click)="salvarEndereco()" label="Salvar Endereço" styleClass="p-button-primary shadow-lg"></p-button>
            </div>
        </ng-template>
    </p-dialog>

    <p-dialog
        appDialogoPadrao="pi pi-phone"
        descricao="Dados de contato da pessoa."
        header="Editar Endereço e Telefones"
        [(visible)]="displayEditarEnderecoDialog"
        [style]="{ width: '650px', maxWidth: '95vw' }"
        [contentStyle]="{ overflow: 'visible' }"
    >
        <form [formGroup]="editarEnderecoForm" class="flex flex-col gap-6 pt-2">
            <div class="flex flex-col gap-4 p-4 bg-slate-50/50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700">
                <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center gap-2 text-blue-600">
                        <i class="pi pi-map-marker"></i>
                        <span class="text-sm font-bold uppercase tracking-wider text-gray-700 dark:text-gray-300">Dados do Endereço</span>
                    </div>
                    <p-button
                        [label]="isEditEnderecoVisible() ? 'Ocultar Endereço' : 'Editar Endereço'"
                        [icon]="isEditEnderecoVisible() ? 'pi pi-chevron-up' : 'pi pi-pencil'"
                        [text]="true"
                        size="small"
                        (onClick)="isEditEnderecoVisible.set(!isEditEnderecoVisible())"
                    ></p-button>
                </div>

                @if (isEditEnderecoVisible()) {
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div class="md:col-span-1 flex flex-col gap-1.5">
                            <label for="edit_cep" class="text-xs font-bold text-slate-500 dark:text-slate-300">CEP</label>
                            <p-inputMask id="edit_cep" mask="99.999-999" formControlName="cep" placeholder="00.000-000" styleClass="w-full"></p-inputMask>
                        </div>
                        <div class="md:col-span-3 flex flex-col gap-1.5">
                            <label for="edit_logradouro" class="text-xs font-bold text-slate-500 dark:text-slate-300">Logradouro</label>
                            <input
                                pInputText
                                id="edit_logradouro"
                                formControlName="logradouro"
                                maxlength="70"
                                class="w-full"
                                [attr.aria-invalid]="campoEnderecoInvalido(editarEnderecoForm, 'logradouro') ? true : null"
                                [attr.aria-describedby]="campoEnderecoInvalido(editarEnderecoForm, 'logradouro') ? 'erro-edit-logradouro' : null"
                            />
                            @if (campoEnderecoInvalido(editarEnderecoForm, 'logradouro')) {
                                <small class="erro-campo" id="erro-edit-logradouro">{{ mensagemErroEndereco(editarEnderecoForm, 'logradouro') }}</small>
                            }
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div class="flex flex-col gap-1.5">
                            <label for="edit_numero" class="text-xs font-bold text-slate-500 dark:text-slate-300">Número</label>
                            <input
                                pInputText
                                id="edit_numero"
                                formControlName="numero"
                                inputmode="numeric"
                                maxlength="10"
                                class="w-full"
                                [attr.aria-invalid]="campoEnderecoInvalido(editarEnderecoForm, 'numero') ? true : null"
                                [attr.aria-describedby]="campoEnderecoInvalido(editarEnderecoForm, 'numero') ? 'erro-edit-numero' : null"
                            />
                            @if (campoEnderecoInvalido(editarEnderecoForm, 'numero')) {
                                <small class="erro-campo" id="erro-edit-numero">{{ mensagemErroEndereco(editarEnderecoForm, 'numero') }}</small>
                            }
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label for="edit_complemento" class="text-xs font-bold text-slate-500 dark:text-slate-300">Complemento</label>
                            <input
                                pInputText
                                id="edit_complemento"
                                formControlName="complemento"
                                maxlength="30"
                                class="w-full"
                                [attr.aria-invalid]="campoEnderecoInvalido(editarEnderecoForm, 'complemento') ? true : null"
                                [attr.aria-describedby]="campoEnderecoInvalido(editarEnderecoForm, 'complemento') ? 'erro-edit-complemento' : null"
                            />
                            @if (campoEnderecoInvalido(editarEnderecoForm, 'complemento')) {
                                <small class="erro-campo" id="erro-edit-complemento">{{ mensagemErroEndereco(editarEnderecoForm, 'complemento') }}</small>
                            }
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label for="edit_bairro" class="text-xs font-bold text-slate-500 dark:text-slate-300">Bairro</label>
                            <input pInputText id="edit_bairro" formControlName="bairro" class="w-full" maxlength="30" />
                            <small *ngIf="editarEnderecoForm.get('bairro')?.errors?.['maxlength']" class="text-red-500 font-medium"> O bairro deve ter no máximo 30 caracteres </small>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div class="md:col-span-2 flex flex-col gap-1.5">
                            <label for="edit_municipio" class="text-xs font-bold text-slate-500 dark:text-slate-300">Município</label>
                            <p-select
                                [options]="municipios()"
                                formControlName="municipio"
                                optionLabel="dsMunicipio"
                                optionValue="id"
                                [filter]="true"
                                filterBy="dsMunicipio"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="38"
                                class="w-full bg-white"
                                placeholder="Selecione o município"
                            >
                            </p-select>
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label for="edit_uf" class="text-xs font-bold text-slate-500 dark:text-slate-300">UF</label>
                            <input
                                pInputText
                                id="edit_uf"
                                formControlName="uf"
                                maxlength="2"
                                class="w-full bg-white"
                                [attr.aria-invalid]="campoEnderecoInvalido(editarEnderecoForm, 'uf') ? true : null"
                                [attr.aria-describedby]="campoEnderecoInvalido(editarEnderecoForm, 'uf') ? 'erro-edit-uf' : null"
                            />
                            @if (campoEnderecoInvalido(editarEnderecoForm, 'uf')) {
                                <small class="erro-campo" id="erro-edit-uf">{{ mensagemErroEndereco(editarEnderecoForm, 'uf') }}</small>
                            }
                        </div>
                    </div>

                    <div class="flex flex-col gap-1.5">
                        <label for="edit_tipo" class="text-xs font-bold text-slate-500 dark:text-slate-300">Tipo</label>
                        <p-select [options]="tiposEndereco" formControlName="tipo" optionLabel="label" optionValue="value" styleClass="w-full bg-white" placeholder="Selecione o tipo"></p-select>
                    </div>
                } @else {
                    <div class="text-sm text-slate-600 dark:text-slate-300 space-y-1">
                        <p><strong>Logradouro:</strong> {{ editarEnderecoForm.get('logradouro')?.value }}</p>
                        <p><strong>Bairro:</strong> {{ editarEnderecoForm.get('bairro')?.value }}</p>
                        <p><strong>CEP:</strong> {{ editarEnderecoForm.get('cep')?.value }}</p>
                    </div>
                }
            </div>

            <div>
                <div class="flex items-center justify-between mb-3">
                    <h4 class="text-sm font-bold text-slate-700 flex items-center gap-2">
                        <i class="pi pi-phone text-slate-400"></i>
                        Lista de Telefones
                    </h4>
                    <p-button [label]="'Adicionar'" [icon]="'pi pi-plus'" [text]="true" size="small" (onClick)="adicionarTelefoneRow()"></p-button>
                </div>

                <div class="space-y-3 max-h-[40vh] overflow-y-auto pr-1" formArrayName="telefones">
                    <ng-container *ngFor="let tel of telefonesFA.controls; let idx = index">
                        <div
                            [formGroupName]="idx"
                            class="group grid grid-cols-12 gap-3 items-center bg-white dark:bg-slate-800 p-3 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm hover:border-slate-100 dark:hover:border-slate-600 transition-all"
                        >
                            <ng-container *ngIf="isTelefoneEditing(idx); else displayMode">
                                <div class="col-span-4">
                                    <label class="block text-[10px] font-bold text-slate-400 dark:text-slate-300 uppercase mb-1">Tipo</label>
                                    <p-select [options]="tiposTelefone" formControlName="tipo" optionLabel="label" optionValue="value" styleClass="w-full" appendTo="body" placeholder="Tipo" (onChange)="ajustarMascaraTelefonePorTipo(idx)"></p-select>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-[10px] font-bold text-slate-400 dark:text-slate-300 uppercase mb-1">DDD</label>
                                    <p-inputMask mask="99" formControlName="ddd" placeholder="00" styleClass="w-full p-inputtext-md text-center font-mono"></p-inputMask>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-[10px] font-bold text-slate-400 dark:text-slate-300 uppercase mb-1">Número</label>
                                    <p-inputMask [mask]="getTelefoneMask(idx)" formControlName="numero" [placeholder]="getTelefonePlaceholder(idx)" styleClass="w-full p-inputtext-md font-mono"></p-inputMask>
                                </div>
                                <div class="col-span-2 flex justify-end items-end h-full pt-4 gap-1">
                                    <button
                                        type="button"
                                        class="w-8 h-8 flex items-center justify-center text-green-500 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer border-none"
                                        (click)="toggleTelefoneEdit(idx, false)"
                                        pTooltip="Concluir edição"
                                        tooltipPosition="left"
                                    >
                                        <i class="pi pi-check"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="w-8 h-8 flex items-center justify-center text-slate-300 hover:text-rose-500 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer border-none"
                                        (click)="removerTelefoneRow(idx)"
                                        pTooltip="Remover telefone"
                                        tooltipPosition="left"
                                    >
                                        <i class="pi pi-trash"></i>
                                    </button>
                                </div>
                            </ng-container>

                            <ng-template #displayMode>
                                <div class="col-span-10 flex flex-col">
                                    <div class="flex items-center gap-2">
                                        <span class="text-[10px] bg-slate-100 dark:bg-slate-600 text-slate-500 dark:text-slate-300 px-2 py-0.5 rounded uppercase font-bold border border-slate-200 dark:border-slate-700">
                                            {{ tel.get('tipo')?.value === 'C' ? 'Celular' : 'Fixo' }}
                                        </span>
                                        <span class="font-mono text-slate-800 dark:text-slate-200 font-bold text-lg"> ({{ tel.get('ddd')?.value }}) {{ formatarNumeroTelefonePorTipo(tel.get('numero')?.value, tel.get('tipo')?.value) }} </span>
                                    </div>
                                </div>
                                <div class="col-span-2 flex justify-end gap-1">
                                    <button
                                        type="button"
                                        class="w-8 h-8 flex items-center justify-center text-blue-400 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer border-none"
                                        (click)="toggleTelefoneEdit(idx, true)"
                                        pTooltip="Editar telefone"
                                        tooltipPosition="left"
                                    >
                                        <i class="pi pi-pencil"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="w-8 h-8 flex items-center justify-center text-slate-300 hover:text-rose-500 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer border-none"
                                        (click)="removerTelefoneRow(idx)"
                                        pTooltip="Remover telefone"
                                        tooltipPosition="left"
                                    >
                                        <i class="pi pi-trash"></i>
                                    </button>
                                </div>
                            </ng-template>
                        </div>
                    </ng-container>

                    <div *ngIf="telefonesFA.length === 0" class="py-8 text-center bg-slate-50 dark:bg-slate-600 rounded-xl border border-dashed border-slate-200 dark:border-slate-700">
                        <i class="pi pi-phone text-slate-300 text-2xl mb-2"></i>
                        <p class="text-xs text-slate-400">Nenhum telefone cadastrado para este endereço.</p>
                    </div>
                </div>
            </div>
        </form>
        <ng-template pTemplate="footer">
            <div class="flex justify-end gap-3 pt-4">
                <p-button icon="pi pi-times" (click)="displayEditarEnderecoDialog = false" label="Fechar" styleClass="p-button-text p-button-secondary"></p-button>
                <p-button icon="pi pi-phone" (click)="salvarTelefones(true)" label="Salvar Telefones" [disabled]="!podeSalvarTelefones()" styleClass="p-button-outlined p-button-info shadow-md"></p-button>
                <p-button icon="pi pi-save" (click)="salvarEdicaoEndereco(); salvarTelefones(true)" label="Salvar Tudo" [disabled]="!podeSalvarTelefones() && enderecoSemTelefonesInvalido" styleClass="p-button-success shadow-md"></p-button>
            </div>
        </ng-template>
    </p-dialog>

    <p-dialog
        appDialogoPadrao="pi pi-envelope"
        descricao="E-mails cadastrados para o contato."
        header="Gerenciar E-mail"
        [(visible)]="displayEmailDialog"
        [style]="{ width: '450px', maxWidth: '90vw' }"
        styleClass="p-0"
        [contentStyle]="{ overflow: 'visible' }"
    >
        <form [formGroup]="emailForm" class="flex flex-col gap-5 pt-4">
            <div class="flex flex-col gap-1.5">
                <label for="emailInput" class="text-sm font-bold text-slate-700">E-mail</label>
                <input pInputText id="emailInput" formControlName="email" class="w-full" placeholder="exemplo@email.com" />
                @if (campoInvalido('email')) {
                    <small class="erro-campo">{{ mensagemErroCampo('email') }}</small>
                }
            </div>
            <div class="flex flex-col gap-1.5">
                <label for="tipoEmail" class="text-sm font-bold text-slate-700">Tipo</label>
                <p-select [options]="tiposEmail" formControlName="tipo" optionLabel="label" optionValue="value" styleClass="w-full" placeholder="Selecione o tipo"></p-select>
            </div>
        </form>
        <ng-template pTemplate="footer">
            <div class="w-full flex justify-end gap-3 pt-4 border-t border-slate-100">
                <p-button icon="pi pi-times" (click)="displayEmailDialog = false" label="Cancelar" styleClass="p-button-text p-button-secondary"></p-button>
                <p-button icon="pi pi-check" (click)="salvarEmail()" label="Salvar" [disabled]="!emailForm.valid" styleClass="p-button-primary shadow-lg"></p-button>
            </div>
        </ng-template>
    </p-dialog>
</div>
